import {FunctionComponent, ReactNode, useState} from "react";
import "./readMore.scss";

interface IProps {
    children: string;
    maxChars: number;
}

export const ReadMore:FunctionComponent<IProps> = ({children, maxChars = 150}) => {
    const text = children;
    const [isReadMore, setIsReadMore] = useState(true);
    const toggleReadMore = () => {
        setIsReadMore(!isReadMore);
    };

    if (text.length < maxChars) {
        return (
            <p className="rd-text">
                {text}
            </p>
        );
    }
    return (
        <p className="rd-text">
            {isReadMore ? text.slice(0, maxChars) : text}
            <span onClick={toggleReadMore} className="read-or-hide">
        {isReadMore ? "...mai mult >" : " mai puțin <"}
      </span>
        </p>
    );
};